module.exports = __webpack_public_path__ + "static/img/QLD-29.8c694b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-29.jpg
// module id = MVYi
// module chunks = 0